const __getUserList = {
  method: "GET",
  url: "user/",
};

export { __getUserList };
